<p-dialog
  [(visible)]="display"
  modal="modal"
  width="500"
  [responsive]="true"
  (onHide)="onCloseClick()"
>
  <p-header>
    {{ 'label.History' | translate }}
  </p-header>
  <div class="view-history">
    <p-table
      [value]="portfolioAccountManagerList"
      showGridlines
      scrollable="true"
      scrollHeight="200px"
    >
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th style="width: 25%">
            {{ 'label.From' | translate }}
          </th>
          <th style="width: 25%">
            {{ 'label.To' | translate }}
          </th>
          <th style="width: 50%">
            {{ 'label.AccountManager' | translate }}
          </th>
        </tr>
      </ng-template>

      <ng-template
        pTemplate="body"
        let-record
        let-expanded="expanded"
        let-columns="columns"
      >
        <tr>
          <td style="width: 25%">
            <span>{{ record.startDate | date : dateFormat }}</span>
          </td>
          <td style="width: 25%">
            <span *ngIf="!record.isCurrent">{{
              record.endDate | date : dateFormat
            }}</span>
          </td>
          <td style="width: 50%">
            <span>{{ record.admin.fullName }}</span>
          </td>
        </tr>
      </ng-template>

      <!-- <p-column header="{{'label.From' | translate}}" [style]="{'width':'25%'}">
              <ng-template let-col let-record="rowData" pTemplate="body">
                <span>{{record.startDate | date:dateFormat}}</span>
              </ng-template>
            </p-column>
            <p-column header="{{'label.To' | translate}}" [style]="{'width':'25%'}" >
                <ng-template let-col let-record="rowData" pTemplate="body">
                  <span *ngIf="!record.isCurrent">{{record.endDate | date:dateFormat}}</span>
                </ng-template>
              </p-column>
              <p-column header="{{'label.AccountManager' | translate}}" [style]="{'width':'50%'}">
                  <ng-template let-col let-record="rowData" pTemplate="body">
                    <span>{{record.admin.fullName}}</span>
                  </ng-template>
                </p-column> -->
    </p-table>
  </div>
</p-dialog>
<p-button
  type="button"
  class="ui-button-secondary top-left"
  (click)="onPortfolioViewHistoryClick()"
  label="{{ 'label.History' | translate }}"
></p-button>
